import React from "react";
import dialogPolyfill from "dialog-polyfill";
import { FormattedMessage } from "react-intl";
import { classes } from "typestyle";
import prettyUrl from "../../helpers/prettyUrl";
import { EventInfo } from "../../types";
import Heading from "../Heading";
import * as styles from "./styles";
import { ReactComponent as IconCross } from "../../assets/icons/icon_cross.svg";
import "dialog-polyfill/dist/dialog-polyfill.css";

interface IProps {
  close: () => void;
  event: EventInfo;
  open: boolean;
}

const PracticalInformationModal: React.FC<IProps> = ({ close, open, event }) => {
  const dialogRef = React.useRef<HTMLDialogElement>(null);

  React.useEffect(() => {
    if (open && dialogRef.current) {
      dialogPolyfill.registerDialog(dialogRef.current);
      dialogRef.current.showModal();
    } else if (!open && dialogRef?.current) {
      dialogPolyfill.registerDialog(dialogRef.current);
      dialogRef.current.close();
    }
  }, [open]);

  return (
    <dialog ref={dialogRef} className={styles.dialogStyle}>
      <div className={classes(styles.infoBox)}>
        <div className={styles.heading}>
          <Heading size="xl2">
            <FormattedMessage
              id={"screens.Event.practicalInfo"}
              defaultMessage={"Practical information"}
            />
          </Heading>
          <button className={styles.closeButton} onClick={() => close()} type="button">
            <IconCross height="16" />
          </button>
        </div>
        <div className={styles.infoBoxContent} translate="yes">
          {event.information.map(({ header, info, informationType }, i) => (
            <div key={i} className={styles.informationBox}>
              <div className={styles.infoBoxText}>
                <span style={{ textAlign: "left" }}> {header} </span>
                <div style={{ textAlign: "left" }}>
                  {informationType === "link" ? (
                    <a
                      href={"https://" + prettyUrl(info)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {prettyUrl(info)}
                    </a>
                  ) : (
                    <span style={{ whiteSpace: "break-spaces", wordBreak: "break-word" }}>
                      {info}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </dialog>
  );
};

export default PracticalInformationModal;
